import { render } from "./imageCompressor.vue?vue&type=template&id=2ecda75a&scoped=true"
import script from "./imageCompressor.vue?vue&type=script&lang=js"
export * from "./imageCompressor.vue?vue&type=script&lang=js"

import "./imageCompressor.vue?vue&type=style&index=0&id=2ecda75a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecda75a"]])

export default __exports__